import { memo } from 'react';

import LogoutIconSVG from '@/assets/logout-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ILogoutIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={LogoutIconSVG} {...props} />;

export const LogoutIcon = memo(ILogoutIcon) as typeof ILogoutIcon;
